export default __webpack_public_path__ + "static/media/h30koritu.fabb1743.mp3";